import { useEffect } from 'react'
import {
  useSharedValue,
  withSpring,
  WithSpringConfig,
  withTiming,
  WithTimingConfig,
} from 'react-native-reanimated'

export type WithConfig = {
  spring?: WithSpringConfig
  timing?: WithTimingConfig
}

const useAnimatedToggle = (value: boolean, config?: WithConfig) => {
  const animation = useSharedValue(value ? 1 : 0)

  useEffect(() => {
    const { spring, timing } = config || {}
    if (timing) {
      animation.set(
        withTiming(value ? 1 : 0, {
          ...timing,
        })
      )
      return
    }

    animation.set(
      withSpring(value ? 1 : 0, {
        overshootClamping: true,
        ...spring,
      })
    )
  }, [value, animation, config])

  return animation
}

export default useAnimatedToggle
